import { OpenFlag } from '@/api/resort/types';
import { useOpenFlagTranslation } from '@/i18n/useOTSTranslation';

const OPEN = 'text-[#3BA82D] [&_svg]:fill-[#3BA82D]';
const PARTIAL = 'text-[#FF9E22] [&_svg]:fill-[#FF9E22]';
const CLOSED = 'text-[#F17850] [&_svg]:fill-[#F17850]';

const classMap: Record<OpenFlag, string> = {
  [OpenFlag.Closed]: CLOSED,
  [OpenFlag.NoReportAvailable]: PARTIAL,
  [OpenFlag.PermanentlyClosed]: CLOSED,
  [OpenFlag.Open]: OPEN,
  [OpenFlag.WeekendsOnly]: OPEN,
  [OpenFlag.TemporarilyClosed]: PARTIAL,
};

export const OpenStatus = ({ flag }: { flag?: OpenFlag }) => {
  const eT = useOpenFlagTranslation();
  return <span className={classMap[flag || OpenFlag.Closed]}>{flag ? eT(flag) : ''}</span>;
};
